import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/bookmarkFilled.svg';

export const IconBookmarkFilled = createIconComponent(Icon);
